import { Service } from "typedi";
import { ModalsService } from "~shared/services/modals.service";
import AppConfirmModal, { AppConfirmModalProps } from "~shared/components/AppConfirmModal.vue";

@Service({
  global: true,
})
export class ConfirmService {
  constructor(private readonly modalsService: ModalsService) {}

  public ask(title: string, message?: string): Promise<boolean> {
    return this.modalsService.open<boolean, AppConfirmModalProps>(AppConfirmModal, {
      title,
      message,
    });
  }
}
